import React from 'react';

import MenuItem from '../components/MenuItem';

class Menu extends React.Component {

  state = { open: false };

  render()  {
    return (
      <div>
        <div className='brand'>
          <h2 className='title'>12 Questions</h2>
        </div>
        <ul>
          <MenuItem link='/' linkText='Dashboard' iconName='tachometer' />
          <MenuItem link='/game' linkText='Game' iconName='cog' />
          <MenuItem link='shop' linkText='Shop' iconName='shopping-cart' />
          <MenuItem link='/questions' linkText='Questions' iconName='list' />
          <MenuItem link='/users' linkText='Users' iconName='group' />
        </ul> 
      </div>
      
    );
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/containers/Menu.js